import React, { useContext } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

import Home from './customer/Home';
import Tickets from './customer/tickets';
import Finances from './customer/security';
import Server from './customer/server';
import Login from './customer/login';
import Logout from './customer/logout';
import Sales from './customer/sales';
import Sora2 from './customer/sora2';
import Calendar from './customer/calendar';
import Advert from './customer/advert';
import SalesDash from './customer/salesdashboard';
import Meeting from './customer/createmeeting';
import Queues from './customer/Queues';
import ViewDashboard from './customer/ViewDashboard';


function App() {
  const user = useContext(AuthContext);
  const location = useLocation();

  // Show admin routes if user is admin and not on /login, otherwise show login
  if (user?.Access === 'admin' && location.pathname !== '/login') {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Home />} />
        <Route path="/tickets" element={<Tickets />} />
         <Route path= "/sales" element={<Sales />} />
         <Route path= "/calendar" element={<Calendar />} />
         <Route path= "/advert" element={<Advert />} />

         <Route path= "/product-updates" element={<Sora2 />} />
         <Route path= "/advert" element={<Advert />} />
        <Route path="/logins" element={<Finances />} />
        <Route path="/server" element={<Server />} />
        <Route path="/queues" element={<Queues />} />
        <Route path="/view" element={<ViewDashboard />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/create-meeting" element={<Meeting />} />
      </Routes>
    );
  }
  if (user?.Access === 'sales' && location.pathname !== '/login') {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/sales-dashboard" replace />} />
        <Route path="/sales-dashboard" element={<SalesDash />} />
        <Route path="/create-meeting" element={<Meeting />} />
        <Route path="/logout" element={<Logout />} />
      </Routes>
        )
  }
  
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default App;
